import React, { useEffect } from 'react';

const FAQ_ITEMS = [
  {
    q: 'Do I need to give Purgr my Instagram password?',
    a: 'No — never. Purgr does not ask for your Instagram login credentials. You only upload two data files that you download directly from Instagram. Your password stays with you.',
  },
  {
    q: 'Is Purgr safe to use?',
    a: 'Yes. Purgr works entirely in your browser using local file processing. Your Instagram files are read on your own device and are never sent to any server. There is no account access, no API calls to Instagram, and no risk of your account being flagged or suspended.',
  },
  {
    q: 'Does Purgr store my Instagram data?',
    a: 'No. Everything runs entirely in your browser. Your Instagram files are read locally on your device and are never uploaded to any server. Once you close or refresh the tab, the data is gone.',
  },
  {
    q: 'Is Purgr affiliated with Instagram?',
    a: 'No. Purgr is an independent tool and is not affiliated with, endorsed by, or sponsored by Instagram or Meta Platforms. Instagram is a trademark of Meta Platforms, Inc.',
  },
  {
    q: 'What files do I upload?',
    a: 'You upload two files from your Instagram data download: following.json (the accounts you follow) and followers_1.json (the accounts that follow you). Both JSON and HTML formats are supported.',
  },
];

const FAQ: React.FC = () => {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQ_ITEMS.map(({ q, a }) => ({
        '@type': 'Question',
        name: q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: a,
        },
      })),
    };

    const existing = document.getElementById('faq-schema');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'faq-schema';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.getElementById('faq-schema')?.remove();
    };
  }, []);

  return (
    <section className="mt-12">
      <h2 className="text-white/50 text-xs font-semibold uppercase tracking-widest mb-5 text-center">
        Frequently Asked Questions
      </h2>
      <div className="space-y-3">
        {FAQ_ITEMS.map(({ q, a }) => (
          <details
            key={q}
            className="glass-card group"
          >
            <summary className="flex items-center justify-between cursor-pointer px-5 py-4 list-none select-none">
              <span className="text-white/90 font-medium text-sm pr-4">{q}</span>
              <span className="text-white/40 group-open:rotate-45 transition-transform duration-200 flex-shrink-0 text-xl leading-none">
                +
              </span>
            </summary>
            <div className="px-5 pb-4">
              <p className="text-white/55 text-sm leading-relaxed">{a}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
